export default __webpack_public_path__ + "static/media/internalhub.f7e87984.jpg";